import { useTranslation } from 'react-i18next';

import { Button } from '@speeki/global-ui-components';

import {
    ButtonsDecorator,
    FormBottomElementWrapper,
} from './FormBottomElement.styled';

interface FormBottomElementProps {
    buttonText: string;
    disabled?: boolean;
    onSubmit: () => void;
}

export const FormBottomElement = ({
    buttonText,
    disabled,
    onSubmit,
}: FormBottomElementProps) => {
    const { t } = useTranslation();

    return (
        <FormBottomElementWrapper>
            <ButtonsDecorator>{t('OR')}</ButtonsDecorator>
            <Button
                disabled={disabled}
                fullWidth
                onClick={onSubmit}
                testId="button_bottom-element"
                type={'button'}
                variant={'secondary'}
            >
                {buttonText}
            </Button>
        </FormBottomElementWrapper>
    );
};
